<template>
  <svg
    width="20"
    height="19"
    viewBox="0 0 20 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.6252 1.45844C14.3502 0.591802 13.5475 0.00292969 12.6391 0.00292969H11.9531C10.9503 0.00292969 10.0892 0.719577 9.90589 1.70566L8.88647 7.18051L9.19202 6.16943C9.45868 5.29167 10.267 4.68891 11.1864 4.68891H14.3752L16.2029 5.32778L17.1751 4.69169C16.2668 4.69169 15.4641 4.10004 15.1891 3.2334L14.6252 1.45567V1.45844Z"
      fill="url(#paint0_radial_1354_1576)"
    />
    <path
      d="M5.58658 16.0382C5.85879 16.9077 6.66433 17.5021 7.57541 17.5021H8.92815C10.067 17.5021 10.9948 16.5882 11.0114 15.4494L11.0836 10.4189L10.8087 11.3328C10.5448 12.2133 9.73369 12.8161 8.81427 12.8161H5.62547L3.97551 12.0633L3.05054 12.8161C3.96162 12.8161 4.76716 13.4105 5.03937 14.2799L5.58658 16.041V16.0382Z"
      fill="url(#paint1_radial_1354_1576)"
    />
    <path
      d="M12.5002 0.00277776H5.20874C3.12547 0.00277776 1.8755 2.68881 1.04219 5.37485C0.0561091 8.5581 -1.23552 12.8135 2.50049 12.8135H5.6754C6.60037 12.8135 7.41702 12.2052 7.67534 11.3164C8.22255 9.44696 9.18086 6.19149 9.93361 3.71379C10.3169 2.45271 10.6364 1.36941 11.1252 0.694425C11.4002 0.316658 11.8558 0 12.5002 0V0.00277776Z"
      fill="url(#paint2_linear_1354_1576)"
    />
    <path
      d="M12.5002 0.00277776H5.20874C3.12547 0.00277776 1.8755 2.68881 1.04219 5.37485C0.0561091 8.5581 -1.23552 12.8135 2.50049 12.8135H5.6754C6.60037 12.8135 7.41702 12.2052 7.67534 11.3164C8.22255 9.44696 9.18086 6.19149 9.93361 3.71379C10.3169 2.45271 10.6364 1.36941 11.1252 0.694425C11.4002 0.316658 11.8558 0 12.5002 0V0.00277776Z"
      fill="url(#paint3_linear_1354_1576)"
    />
    <path
      d="M7.49756 17.5022H14.789C16.8723 17.5022 18.1223 14.8161 18.9556 12.1301C19.9417 8.94684 21.2361 4.69141 17.4973 4.69141H14.3224C13.3974 4.69141 12.5808 5.29972 12.3224 6.18859C11.7752 8.05798 10.8169 11.3107 10.0642 13.7884C9.68083 15.0495 9.3614 16.1328 8.87252 16.8077C8.59753 17.1855 8.14199 17.5022 7.49756 17.5022Z"
      fill="url(#paint4_radial_1354_1576)"
    />
    <path
      d="M7.49756 17.5022H14.789C16.8723 17.5022 18.1223 14.8161 18.9556 12.1301C19.9417 8.94684 21.2361 4.69141 17.4973 4.69141H14.3224C13.3974 4.69141 12.5808 5.29972 12.3224 6.18859C11.7752 8.05798 10.8169 11.3107 10.0642 13.7884C9.68083 15.0495 9.3614 16.1328 8.87252 16.8077C8.59753 17.1855 8.14199 17.5022 7.49756 17.5022Z"
      fill="url(#paint5_linear_1354_1576)"
    />
    <path
      d="M18.989 12.8135H7.57261C7.0142 12.8135 6.56152 13.2662 6.56152 13.8246V17.7383C6.56152 18.2967 7.0142 18.7494 7.57261 18.7494H18.989C19.5474 18.7494 20 18.2967 20 17.7383V13.8246C20 13.2662 19.5474 12.8135 18.989 12.8135Z"
      fill="black"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7.37817 13.9497V17.5691H8.0476V14.9608L8.78091 16.408H9.22812L9.94477 14.9608V17.5691H10.6364V13.9497H9.86422L9.02535 15.6302L8.19204 13.9497H7.37817ZM12.3836 17.6163C11.9864 17.6163 11.6753 17.5218 11.4531 17.3302C11.2336 17.1413 11.1225 16.8552 11.1225 16.4719H11.7836C11.7836 16.6524 11.8364 16.7941 11.9392 16.8968C12.0447 16.9996 12.1919 17.0496 12.3808 17.0496C12.5503 17.0496 12.678 17.008 12.7669 16.9218C12.8586 16.8357 12.903 16.6996 12.903 16.5135C12.903 16.3274 12.8475 16.2052 12.7364 16.1246C12.628 16.0413 12.4836 15.9997 12.3086 15.9997H12.0919V15.4552H12.328C12.4864 15.4552 12.6114 15.4136 12.7058 15.3274C12.8002 15.2413 12.8447 15.1275 12.8447 14.9858C12.8447 14.8441 12.803 14.7358 12.7197 14.6691C12.6364 14.5997 12.5225 14.5664 12.378 14.5664C12.2197 14.5664 12.0947 14.6108 12.0058 14.6997C11.9169 14.7886 11.8753 14.908 11.8753 15.0636H11.217C11.217 14.8219 11.267 14.6219 11.367 14.4664C11.4697 14.3108 11.6086 14.1941 11.7836 14.1164C11.9586 14.0386 12.1558 13.9969 12.3753 13.9969C12.578 13.9969 12.7641 14.0303 12.9364 14.0969C13.1086 14.1636 13.2475 14.2636 13.3502 14.3997C13.4558 14.5358 13.5086 14.7108 13.5086 14.9247C13.5086 15.1386 13.4558 15.3136 13.353 15.4413C13.2502 15.5691 13.1141 15.658 12.9391 15.7108C13.1308 15.7497 13.2891 15.8385 13.4141 15.9802C13.5419 16.1191 13.6058 16.3135 13.6058 16.5635C13.6058 16.9052 13.4947 17.1663 13.2752 17.3468C13.0558 17.5274 12.7586 17.6163 12.3836 17.6163ZM14.5474 17.4385C14.7474 17.5579 14.9724 17.619 15.2252 17.619C15.4779 17.619 15.6946 17.5691 15.8696 17.4691C16.0474 17.3691 16.1807 17.2302 16.2724 17.0552C16.364 16.8774 16.4085 16.6746 16.4085 16.4441C16.4085 16.2135 16.364 16.0052 16.2751 15.8441C16.1863 15.6802 16.064 15.558 15.9085 15.4747C15.7557 15.3913 15.5835 15.3469 15.3918 15.3469C15.2307 15.3469 15.0891 15.3719 14.9669 15.4247C14.8474 15.4774 14.7391 15.5469 14.6474 15.633C14.6363 15.6441 14.6252 15.6552 14.6113 15.6663C14.6224 15.3191 14.6752 15.0552 14.7669 14.8775C14.8752 14.6691 15.028 14.5664 15.2252 14.5664C15.3474 14.5664 15.4446 14.5997 15.5196 14.6691C15.5974 14.7358 15.6474 14.8358 15.6752 14.9719H16.3363C16.289 14.6608 16.1724 14.4219 15.9807 14.2525C15.7918 14.083 15.5391 13.9997 15.2224 13.9997C14.9669 13.9997 14.7391 14.0664 14.5391 14.1969C14.3391 14.3247 14.1835 14.5247 14.0724 14.7969C13.9585 15.0663 13.903 15.4108 13.903 15.833C13.903 16.2552 13.9613 16.5996 14.0752 16.8635C14.1891 17.1246 14.3446 17.3163 14.5419 17.4385H14.5474ZM14.6169 16.183C14.6641 16.1358 14.7169 16.0941 14.7752 16.0552C14.9196 15.958 15.0835 15.908 15.2668 15.908C15.4057 15.908 15.5113 15.9552 15.5891 16.0524C15.6668 16.1469 15.7057 16.2802 15.7057 16.4496C15.7057 16.6191 15.6641 16.7691 15.5835 16.883C15.5057 16.9968 15.3835 17.0552 15.2224 17.0552C15.1196 17.0552 15.0196 17.0218 14.9252 16.9552C14.8307 16.8857 14.7557 16.7774 14.6974 16.6246C14.653 16.508 14.628 16.3608 14.6169 16.183ZM17.3335 17.4996C17.5223 17.5774 17.7307 17.619 17.964 17.619C18.1973 17.619 18.4001 17.5746 18.5834 17.4829C18.7667 17.3913 18.914 17.2552 19.0223 17.0746C19.1306 16.8913 19.1834 16.6635 19.1834 16.3885C19.1834 16.1135 19.1334 15.8941 19.0306 15.7247C18.9306 15.5552 18.7973 15.433 18.6362 15.3552C18.4723 15.2774 18.2973 15.2358 18.1112 15.2358C17.9668 15.2358 17.8446 15.258 17.7362 15.3052C17.6334 15.3497 17.5529 15.4024 17.5001 15.4636L17.564 14.6358H18.9112V14.0469H17.0085L16.8557 15.9969H17.4723C17.5223 15.933 17.5862 15.883 17.664 15.8413C17.7418 15.7997 17.8362 15.7802 17.9473 15.7802C18.1057 15.7802 18.2334 15.8274 18.3306 15.9247C18.4306 16.0191 18.4806 16.1746 18.4806 16.3885C18.4806 16.6191 18.4334 16.7885 18.339 16.8968C18.2445 17.0052 18.1223 17.058 17.9668 17.058C17.8029 17.058 17.6696 17.0135 17.5668 16.9218C17.464 16.8274 17.4112 16.7024 17.4112 16.5413H16.7251C16.7251 16.783 16.7807 16.9857 16.889 17.1468C17.0001 17.3052 17.1501 17.4246 17.339 17.5052L17.3335 17.4996Z"
      fill="white"
    />
    <defs>
      <radialGradient
        id="paint0_radial_1354_1576"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(16.2747 7.00689) rotate(-130.29) scale(7.67756 7.26647)"
      >
        <stop offset="0.1" stop-color="#00AEFF" />
        <stop offset="0.77" stop-color="#2253CE" />
        <stop offset="1" stop-color="#0736C4" />
      </radialGradient>
      <radialGradient
        id="paint1_radial_1354_1576"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(4.59487 13.7266) rotate(50.26) scale(6.94703 6.81926)"
      >
        <stop stop-color="#FFB657" />
        <stop offset="0.63" stop-color="#FF5F3D" />
        <stop offset="0.92" stop-color="#C02B3C" />
      </radialGradient>
      <linearGradient
        id="paint2_linear_1354_1576"
        x1="5.93095"
        y1="1.45829"
        x2="6.92258"
        y2="13.2052"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.16" stop-color="#0D91E1" />
        <stop offset="0.49" stop-color="#52B471" />
        <stop offset="0.65" stop-color="#98BD42" />
        <stop offset="0.94" stop-color="#FFC800" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_1354_1576"
        x1="6.03094"
        y1="-0.0111108"
        x2="6.56982"
        y2="12.8024"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#3DCBFF" />
        <stop offset="0.25" stop-color="#0588F7" stop-opacity="0" />
      </linearGradient>
      <radialGradient
        id="paint4_radial_1354_1576"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(16.9882 3.17462) rotate(109.72) scale(17.069 20.8466)"
      >
        <stop offset="0.07" stop-color="#8C48FF" />
        <stop offset="0.5" stop-color="#F2598A" />
        <stop offset="0.9" stop-color="#FFB152" />
      </radialGradient>
      <linearGradient
        id="paint5_linear_1354_1576"
        x1="13.7641"
        y1="3.89976"
        x2="13.7585"
        y2="7.38855"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.06" stop-color="#F8ADFA" />
        <stop offset="0.71" stop-color="#A86EDD" stop-opacity="0" />
      </linearGradient>
    </defs>
  </svg>
</template>
